export interface IMessage {
  peer_id: string;
  peer_msg: string;
  peer_name?: string;
  room_id: string;
  to_peer_id?: string;
  to_peer_name?: string;
  timestamp: string;
  originalTimestamp?: string; // original timestamp when message was first sent
  chatMessageId?: string;
  isShown?: boolean; // if the notification already presented[ for notification messageو Notification came out and he saw it.
  // It's not a thing. Every time New Notification comes, he wants to see it, but he doesn't delete it from the list, so he can see the red dots when he reads the message by deleting it. ]
  isRead?: boolean;
  isPinned?: boolean;
  operation?: EMessageOperations; // to support any kind of message socket operation if needed.
  operationData?: Partial<IMessage>;
  file?: any;
  type?: EMessageType;
  peer_record_id?: string; // record id of the peer who send the message
  to_peer_record_id?: string; // record id of the peer to whom the message is sent, used for private messages
  isEditing?: boolean; // flag to indicate if the message is being edited
  edited?: boolean;
  metadata?: {
    source: 'calculator';
    mode?: 'basic' | 'scientific' | 'converter';
  };
}

export interface IMessageFile {
  fileExtension: string;
  fileName: string;
  fileSize: number;
  fileUrl: string;
}

export enum EMessageOperations {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum EMessageType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  PANELIST = 'PANELISTS_GROUP',
}

export interface IReceiverMessageData {
  key: EMessageType;
  value: string;
}
